<template>
  <div class="row col-12 py-3 bg-white mt-2 rounded border post">
    <div class="col-12">
      <label><small><b>Nos fale o que você esta pensando</b></small></label>
      <textarea class="form-control textarea" rows="3" v-model="form.text" maxlength="1000"></textarea>
    </div>

    <div class="my-2">
      <input type="file" class="collapse" @change="loadFiles" id="files" accept=".jpg,.jpeg,.png,.pdf">
      <post-image :files="files" :progress="progress" @deleteImage="deleteImage" />
    </div>

    <div class="col-12 d-flex justify-content-end mt-2">
      <label class="btn btn-sm btn-outline-dark mr-1" for="files"><i class="fa fa-paperclip"></i></label>
      <!-- <button class="btn btn-sm btn-outline-dark mr-1"><i class="fa fa-paperclip"></i></button> -->
      <button class="btn btn-sm btn-outline-dark" @click="post">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="saving"></span>
        Postar
      </button>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import Form from 'vform'
import Swal from 'sweetalert2'
import { mapGetters } from 'vuex'

import PostImage from './Image'

export default {
  components: {
    "post-image": PostImage
  },
  data () {
    return {
      saving: false,
      form: new Form({
        id: undefined,
        user: undefined,
        text: undefined,
      }),
      files: undefined,
      progress: 0,
    }
  },
  computed: {
    ...mapGetters({
      user: "getCurrentUser"
    })
  },
  methods: {
    loadFiles: function ($e) {
      this.files = undefined
      this.files = $e.target.files[0]
    },

    post: function () {
      if (!this.form.text) return

      this.saving = true
      this.form.user = this.user.id

      this.form.post(`/post`)
        .then( res => {
          this.form.text = undefined

if ( this.files != undefined ) {
            this.uploadFileStorage( res.data.data.id )
          } else {
            this.$emit('reloadPosts')
          }

          Swal.fire({
            icon: 'success',
            title: 'Postado!',
            showConfirmButton: false,
            timer: 1500,
          })
        })
        .catch( err => {
          console.error( err )
        })
        .then( () => {
          this.saving = false
        })
    },

    uploadFileStorage: async function (id) {
      let formData = new FormData()
      formData.append('files', this.files)
      formData.append('post', id)

      await Axios.post(`/post/file/upload`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: progress => {
            this.progress = ((progress.loaded * 100) / progress.total).toFixed(0)
          }
        }
      )
        .then((res) => {
          return res.data
        })
        .catch((err) => {
          console.error(err)
        })
        .then( () => {
          this.progress = 0
          this.files = undefined
          this.$emit('reloadPosts')
        })
    },
    deleteImage: function () {
      this.files = undefined
    }
  }
}
</script>
